import { Form, Input } from "antd";

const InputPassword = ({
  rules,
  placeholder,
  label,
  classname,
  wrapClassname,
}) => {
  return (
    <Form.Item
      wrapClassname={wrapClassname}
      label={label}
      name="password"
      rules={rules}
    >
      <Input.Password iconRender={()=>false} classname={classname} placeholder={placeholder} />
    </Form.Item>
  );
};

export default InputPassword;
